import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';

const NotFound: React.FC = () => (
  <section className="section text-center">
    <Container>
      <h1 className="section-title">Page not found</h1>
      <hr className="section-rule" />
      <p className="lede mx-auto mb-4">
        That page is not here. It may have moved when the site was rebuilt.
      </p>
      <Link to="/" className="btn btn-primary px-4">Back to the home page</Link>
    </Container>
  </section>
);

export default NotFound;
